module.exports = __webpack_public_path__ + "static/img/inquiry_empty.962cdbac.png";